import allLang from './lang.js'

export function groupBy(array, f) {
    let groups = {};
    array.forEach(function (o) {
        let group = JSON.stringify(f(o));
        groups[group] = groups[group] || [];
        groups[group].push(o);
    });
    return Object.keys(groups).map(function (group) {
        return groups[group];
    });
}


//处理登录返回错误的问题(分语言)
export function loginError(description, lang) {
    let selfDefintion = ''
    switch (description) {
        case 'Dreame user not found':
            selfDefintion = allLang[lang].useNotFound;
            break;
        case 'phone not found':
            selfDefintion = allLang[lang].phoneNotFound;
            break;
        case 'user password not match':
            selfDefintion = allLang[lang].notMatch;
            break;
        case 'exceed max login attempts':
            selfDefintion = allLang[lang].errorMuch;
            break;
        case 'Invalid or expired verification':
            selfDefintion = allLang[lang].codeErr;
            break;
        case "Missing verification key or code":
            selfDefintion = allLang[lang].codeErr;
            break;
        default:
            return ""
    }
    return selfDefintion


}
//处理验证码返回错误(分语言)
export function valicodeError(code, lang) {
    let errorDesc = '';
    switch (code) {
        case 11002:
            errorDesc = allLang[lang].codeSendErr;
            break;
        case 11003:
            errorDesc = allLang[lang].codeSendFrequent;
            break;
        case 11004:
            errorDesc = allLang[lang].codeSendLimit;
            break;
        default:
            return allLang[lang].codeSendErr
    }
    return errorDesc
}

//处理未注册的手机号码(分语言)
export function unregisteredresolve(lang) {
    return allLang[lang].unregisterPhone
}

//处理音响名字切换语言
// export function changVoiceType(originType) {
//     let convertVoiceType;
//     switch (originType) {
//         case 'google':
//             convertVoiceType = 'google';
//             break;
//         case 'Amazon Alexa':
//             convertVoiceType = 'Amazon Alexa';
//             break;
//         case 'Baidu DuerOS':
//             convertVoiceType = '小度';
//             break;
//         case '小度':
//             convertVoiceType = 'Baidu DuerOS';
//             break;
//         case '天猫精灵':
//             convertVoiceType = 'Aligenie';
//             break;
//         case 'Aligenie':
//             convertVoiceType = '天猫精灵';
//             break;
//         default:
//             return ""
//     }
//     return convertVoiceType

// }